import React from 'react';
import { ResponsiveContainer, PieChart as Chart, Pie, Cell } from 'recharts';

import { useProductDetails } from '@helpers/hooks/pages/dashboard/productAnalytics/useProductDetails';

import * as S from './styles';

const Boleto: React.FC = () => {
  const { productFinancialDetailsReport } = useProductDetails();

  const { boleto } = productFinancialDetailsReport;

  const data = [
    {
      name: 'Conversão',
      value: boleto.conversion,
    },
    {
      name: 'Total',
      value: 100 - boleto.conversion,
    },
  ];

  const colors = ['#873BFF', '#515562'];

  return (
    <S.ChartWrapper>
      <ResponsiveContainer width="100%">
        <Chart>
          <Pie
            data={data}
            innerRadius="70%"
            outerRadius="100%"
            fill="#000"
            paddingAngle={0}
            dataKey="value"
            strokeOpacity={0}
          >
            {data.map((pie, index) => (
              <Cell key={`cell-${pie.name}`} fill={colors[index]} />
            ))}
          </Pie>
        </Chart>
      </ResponsiveContainer>
    </S.ChartWrapper>
  );
};

export default Boleto;
